import React, { ReactNode } from 'react';
import {
  ApiButton,
  Box,
  Button,
  ContentTemplate,
  KeyValue,
  SectionHeader,
  Typography,
} from 'web-library';
import { useTranslation } from 'react-i18next';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { MutationStatus } from 'react-query';

const useStyles = makeStyles()((theme) =>
({
  getStartedContent: {
    marginBottom: theme.spacing(7),
  },
  startApplicationButton: {
    marginTop: theme.spacing(1),
  },
  getStartedStatement: {
    marginBottom: theme.spacing(4),
  },
  continueApplicationElement: {
    marginBottom: theme.spacing(1),
  },
  errorMsgContainer: {
    marginBottom: theme.spacing(1),
  },
  validationMsg: {
    fontWeight: 600,
    color: theme.color.state.stateError,
  },
}));

export interface InstructionsContentProps {
  isContinueApplication: boolean;
  applicationId?: string;
  examLevel?: string;
  continueApplication: () => void;
  startApplicationStatus: MutationStatus;
  startApplication: () => void;
  validationMsg?: string;
  instructionNotes: ReactNode;
}

const InstructionsContent = ({
  isContinueApplication,
  applicationId,
  examLevel,
  continueApplication,
  startApplicationStatus,
  startApplication,
  validationMsg,
  instructionNotes,
}: InstructionsContentProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <>
      <ContentTemplate isDividerBottom>{instructionNotes}</ContentTemplate>
      <ContentTemplate continuous>
        <Box className={classes.getStartedContent}>
          {isContinueApplication ? (
            <>
              <SectionHeader title={t('specialConsideration->>Instructions.GetStarted')} />
              <Typography className={classes.getStartedStatement}>
                {t('specialConsideration->>Instructions.GetStartedStatement')}
              </Typography>
              <Box className={classes.continueApplicationElement}>
                <KeyValue
                  id="applicationId"
                  keyText={t('specialConsideration->>Instructions.ApplicationId')}
                  valueText={applicationId}
                />
              </Box>
              <Box className={classes.continueApplicationElement}>
                <KeyValue
                  id="examLevel"
                  keyText={t('specialConsideration->>Instructions.ExamLevel')}
                  valueText={examLevel}
                />
              </Box>
              <Button id="button-continue-application" onClick={continueApplication}>
                {t('specialConsideration->>Instructions.ContinueApplication')}
              </Button>
            </>
          ) : (
            <>
              <Box className={classes.errorMsgContainer}>
                {validationMsg && (
                  <Typography className={classes.validationMsg} variant="body2">
                    {validationMsg}
                  </Typography>
                )}
              </Box>
              <ApiButton
                id="button-start-application"
                className={classes.startApplicationButton}
                status={startApplicationStatus}
                onClick={startApplication}
              >
                {t('specialConsideration->>Instructions.StartApplication')}
              </ApiButton>
            </>
          )}
        </Box>
      </ContentTemplate>
    </>
  );
};

export default InstructionsContent;
